import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  nl: {
    common: {
      back: 'Terug',
    },
    metadata: {
      site_name: 'P.E.N.T.A.G.O.N.',
      home_title: 'P.E.N.T.A.G.O.N.',
      members_title: 'Leden - P.E.N.T.A.G.O.N.',
      board_title: 'Bestuur - P.E.N.T.A.G.O.N.',
      gallery_title: "Foto's - P.E.N.T.A.G.O.N.",
      album_title: 'Fotoalbum - P.E.N.T.A.G.O.N.',
    },
    navigation: {
      home: 'Home',
      members: 'Leden',
      board: 'Bestuur',
      gallery: "Foto's",
      login: 'Inloggen',
      brand_alt: 'P.E.N.T.A.G.O.N.-wapen',
    },
    home: {
      title: 'A.H.D. P.E.N.T.A.G.O.N.',
      motto: 'Voor iedereen, behalve echte illuminaten, een ondoorgrondelijk geheim.',
      membership_heading: 'Waarom lid worden bij A.H.D. P.E.N.T.A.G.O.N.?',
      introduction_one: 'A.H.D. P.E.N.T.A.G.O.N. is een Amsterdams herendispuut gelieerd aan studentenvereniging NoNoMes. Elke dinsdag hebben we een borrel en elk weekend is er altijd wel iemand die een biertje wil drinken of de hele nacht wil doorfeesten. Verder hebben we typisch studentikoze activiteiten als gala’s, rally’s, de jaarlijkse dies, vakanties en nog veel meer.',
      introduction_two: 'Door ons grote reünistenbestand en gedreven houding zijn er volop mogelijkheden om jezelf verder te ontwikkelen buiten je studie, of juist nog dieper je vakgebied in te duiken. Last but not least vind je ongetwijfeld snel een kamer in een van onze dispuutshuizen en geniet je van al onze prachtige, altijd unieke, activiteiten.',
      introduction_three: 'Stuur ons een DM op Instagram voor meer informatie of om een keer langs te komen op een van onze borrels!',
    },
    social: {
      instagram: 'Volg P.E.N.T.A.G.O.N. op Instagram',
      facebook: 'Volg P.E.N.T.A.G.O.N. op Facebook',
    },
    members: {
      active: 'Actief',
      alumni: 'Reünisten',
    },
    boards: {
      current_heading: 'H.T.',
      former_heading: 'E.T.',
      member: 'Dhr. {name}',
      founding_year: "Oprichtingsbestuur '89",
    },
    gallery: {
      open_album: 'Open album {title}',
      photo_alt: '{album}, foto {number} van {total}',
      guatemala: {
        title: "Guatemala '19",
        caption: 'Lustrum VI',
        description: 'Lustrumreis naar Guatemala',
        cover_alt: 'Lustrumreis naar Guatemala',
      },
      gala: {
        title: "Gala '18",
        caption: 'Lustrum VI',
        description: "Lustrumgala december '18",
        cover_alt: 'Lustrumgala P.E.N.T.A.G.O.N.',
      },
      burgerdag: {
        title: "Burgerdag '18",
        caption: '05.05.2018',
        description: '…',
        cover_alt: "Burgerdag '18",
      },
    },
  },
};

export default new VueI18n({
  locale: 'nl',
  fallbackLocale: 'nl',
  messages,
});
